<template>
  <section class="services" id="services">
        <div class="title-container">
            <h2 class="title">Usługi</h2>
            <h3 class="description">Czyli co mogę dla Ciebię zrobić?</h3>
        </div>
        <div class="service-container">
            <div class="card">
                <div class="service-box">
                    <div class="image-wrapper">
                        <img class="image" src="@/assets/icon1.png" alt="">
                        <img class="image-hover" src="@/assets/icon1-alternative.png" alt="">
                    </div>
                    <h3>Strony internetowe</h3>
                    <p>Tworzę szybkie, responsywne i atrakcyjne strony internetowe</p>
                    <!-- <div class="more">
                        <a href="#">więcej</a>
                    </div> -->
                </div>
            </div>
            <div class="card">
                <div class="service-box">
                    <div class="image-wrapper">
                        <img class="image" src="@/assets/icon3.png" alt="">
                        <img class="image-hover" src="@/assets/icon3-alternative.png" alt="">
                    </div>
                    <h3>Montaż wideo</h3>
                    <p>Potrzebujesz czegoś do zmontowania? Chętnie się tym zajmę</p>

                    <!-- <div class="more">
                        <a href="#">więcej</a>
                    </div> -->
                </div>
            </div>
            <div class="card">
                <div class="service-box last-box">
                    <div class="image-wrapper">
                        <img class="image" src="@/assets/icon2.png" alt="">
                        <img class="image-hover" src="@/assets/icon2-alternative.png" alt="">
                    </div>
                    <h3>Social Media Marketing</h3>
                    <p>Szukasz osoby do zarządania lub prowadzenia swojego profilu</p>
                    <!-- <div class="more">
                        <a href="#">więcej</a>
                    </div> -->
                </div>
            </div>
             <div class="card">
                <div class="service-box last-box">
                    <div class="image-wrapper">
                        <img class="image" src="@/assets/icon4.png" alt="">
                        <img class="image-hover" src="@/assets/icon4-alternative.png" alt="">
                    </div>
                    <h3>Wizytówka Google Maps</h3>
                    <p>Stworzę profesjonalną wizytówkę dla Twojej firmy w Google</p>
                    <!-- <div class="more">
                        <a href="#">więcej</a>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="spacer blob1"></div>
        <div class="spacer blob2"></div>
  </section>
  
</template>

<script>
export default {
    name: "Services",
}
</script>

<style lang="scss" scoped>

section.services {
    padding: 4rem 0 8rem;
    position: relative;

    @media (min-width: 2250px) {
        padding: 7rem 0 11rem;
    }

    @media(max-width:1024px) {
        padding: 2rem 0 4.5rem;
    }

    .spacer {
    aspect-ratio: 900/600;
    width: 44%;
    opacity: 90%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    z-index: -1;

    @media(max-width: 768px) {
        width: 47%;
    }
    @media(max-width: 425px) {
        width: 65%;
    }
}


.blob1 {
    background-image: url('@/assets/blob2.svg');
    position: absolute;
    top: -7%;
    left: -20%;
    transform: rotate(290deg);
     filter: blur(10px);
     @media (max-width:425px) {
     left: -23%;
     top: -10.5%;
      }
}


  .blob2 {
      background-image: url('@/assets/blob5.svg');
      position: absolute;
      top: -23%;
      left: 53%;
      transform: rotate(121deg);
      filter: blur(9px);

      @media (max-width:1024px) {
      top: -2%;
      left: 53%;
      filter: blur(10px);
      overflow: hidden;
      }

      @media (max-width:768px) {
      display: none;
      }

      @media (max-width:425px) {
      top: -2%;
      left: 54%;
      display: none;
      }
  }

  .title-container {
        text-align: center;
        padding-bottom: 1.75rem;
         @media (min-width: 2250px) {
            padding-bottom: 3rem; 
         }

         @media (max-width: 1024px) {
            padding-bottom: 2rem;
         }

         @media (max-width: 768px) {
            padding-bottom: 1.5rem;
         }

        .title {
            font-size: 2.5rem;
            font-family: 'Nunito', sans-serif;
             @media (min-width: 2250px){
              font-size: 3.05rem;
            }

            @media (max-width: 1024px) {
              font-size: 2.4rem;
            }
        }
        .description {
            font-family: 'Nunito', sans-serif;
            font-size: 1.3rem;
             @media (min-width: 2250px){
              font-size: 1.8rem;
            }

             @media (max-width: 1024px) {
              font-size: 1.25rem;
            }
        }
    }

.service-container {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
     gap: 4.5rem;
     padding: 0rem 8rem;
        @media (min-width: 2250px) {
            gap: 5rem;
        }

         @media(max-width: 1024px) {
            gap: 3rem;
          
         }

     @media (max-width: 425px) {
        padding: 0 3.5rem;
     }

     @media (max-width: 395px) {
        padding: 0 2.5rem;
        display: flex;
        flex-direction: column;
     }


     .card {
    .service-box {
        padding: 3rem 2rem 2rem;
        border-radius: .5rem;
        background: linear-gradient(#ffffff 50%, #22262c 50%);
        background-size: 100% 200%;
        background-position: 0 2.5%;
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .1);
        border: .1rem solid rgba(0, 0, 0, .1);
        text-align: center;
        transition: all 0.5s ease;

        @media (min-width: 2250px) {
        padding: 4rem 3rem 3rem;
    }

    @media(max-width: 425px) {
        padding: 2rem 1rem 1rem;
    }

    @media(max-width: 395px) {
        padding: 1.5rem 1rem 0.5rem;
    } 

        .image-wrapper {
            position: relative;
        }

        img {
            position: absolute;
            top: 25%;
            left: 50%;
            transform: translateX(-50%);
            transition: .5s;
            width: 72px;
        }
        .image-hover {
            opacity: 0;
            transition: .5s;
        }
        h3 {
            font-size: 1.45rem;
            padding: 5.5rem 0 0.9rem 0;
            font-weight: 500;
            transition: all 0.3s ease;
            @media (min-width: 2250px) {
                padding-top: 5.8rem;
                font-size: 1.65rem;
    }
    @media(max-width:425px) {
        font-size: 1.4rem;
    }
        }
        p {
            font-size: 0.95rem;
            padding-bottom: 2rem;
            font-family: 'Poppins', sans-serif;
            
            transition: all 0.3s ease;
            @media (min-width: 2250px) {
                font-size: 1.2rem;
    }
    @media(max-width:425px) {
        font-size: 0.9rem;
    }
        }
    }

      

    .last-box {
         display: grid;
        align-items: center;
        justify-items: center;
       
    }
 }
    .card:hover  {
        .service-box {
        background-position: 0 100%;
         cursor: pointer;
            
            h3 {
                color: #fff;
           
            }
            p {
                color: #eee;
            }
              .image-hover {
            opacity: 1;
            transition: .5s;
        }
        .image {
            opacity: 0;
            transition: .5s;
        }
        }
    }
}
}


</style>